import type { ErrorEvent, StackFrame } from '@sentry/nextjs'
import { ignoredErrorTypes } from './constants'

export const beforeSend = (event: ErrorEvent) => {
  const exceptions = event.exception?.values ?? []
  const frames = exceptions.flatMap(({ stacktrace }) => stacktrace?.frames ?? [])

  const hasIgnoredErrorType = exceptions.some(
    ({ type }) => type !== undefined && ignoredErrorTypes.includes(type),
  )

  const hasSomeExternalFrame = frames.some(checkExternalFrame)

  const hasSomeChromeExtensionFrame = frames.some(checkChromeExtensionFrame)

  return hasIgnoredErrorType || hasSomeExternalFrame || hasSomeChromeExtensionFrame ? null : event
}

const checkExternalFrame = ({ filename }: StackFrame) => {
  if (!process.env.NEXT_PUBLIC_STATIC_ASSETS_HOST) return false

  if (filename) {
    return (
      filename.startsWith('http') &&
      !filename.startsWith(process.env.NEXT_PUBLIC_STATIC_ASSETS_HOST)
    )
  }
  return false
}

const checkChromeExtensionFrame = ({ filename }: StackFrame) => {
  if (filename) {
    return filename.startsWith('chrome-extension://')
  }
  return false
}
